import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import Loader from '../../../components/ui/Loader/Loader';

function RootCauseAnalysis(props) {
    const access_token = useSelector(state => state.auth.access_token);
    const rcaDataSaveAPI = IAM_API_BASE_URL_2 + "/ticket/rca_add";
    const rcaDatadeatilAPI = IAM_API_BASE_URL_2 + "/ticket/rca_get";

    const [tableData, setTableData] = useState([
        { id: 1, point: '', reason: '', cause: '' },
    ]);
    const [rca_loading, setRca_loading] = useState(false);
    const [rcaDetailLoading, setRcaDetailLoading] = useState(false);
    const [finalConclusion, setFinalConclusion] = useState('');
    const [actionPlan, setActionPlan] = useState('');
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        if (props.ticketData && props.ticketData.activity_id) {
            fetchRCAData(props.ticketData.activity_id);
        }
    }, [props.ticketData]);

    const fetchRCAData = (activityId) => {
        setRcaDetailLoading(true)
        HttpAPICall.withAthorization('GET', `${rcaDatadeatilAPI}/${activityId}`, access_token, {}, {}, (resp) => {
            if (resp.data) {
                const { rca_data, final_conclusion, action_plan } = resp.data;
                setTableData(rca_data && rca_data.length ? rca_data : [{ id: 1, point: '', reason: '', cause: '' }]);
                setFinalConclusion(final_conclusion || "");
                setActionPlan(action_plan || "");
            }
            setRcaDetailLoading(false)
        });
    };

    const handleInputChange = (id, field, value) => {
        let newData = [...tableData];

        if (field === 'cause') {
            newData[id - 1][field] = value;

            if (id < newData.length) {
                newData[id].point = `Why  ${value} happened ?`;
            }
            else if (newData.length < 5) {
                newData.push({
                    id: newData.length + 1,
                    point: `Why  ${value} happened ?`,
                    reason: '',
                    cause: '',
                });
            }
        } else {
            newData = newData.map(d => d.id === id ? { ...d, [field]: value } : d);
        }

        setTableData(newData);
    };

    const handleSave = (event) => {
        event.preventDefault();
        setRca_loading(true);

        const SaveData = {
            ticket_id: props.ticketData.activity_id,
            rca_data: tableData,
            final_conclusion: finalConclusion,
            action_plan: actionPlan
        };

        HttpAPICall.withAthorization('POST', rcaDataSaveAPI, access_token, {}, SaveData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            setEditMode(false);
        }).then(() => {
            setRca_loading(false);
        });
    };

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    if (rcaDetailLoading) {
        return <Loader />;
    }

    return (
        <div className="container-fluid my-4 px-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="m-0 font-weight-bold" style={{ fontSize: '1.1rem' }}>5-Why analysis</h6>
                <button
                    type="button"
                    className="btn btn-link p-0 text-primary text-decoration-none"
                    style={{ fontSize: '0.9rem' }}
                    onClick={toggleEditMode}
                >
                    {editMode ? 'View' : 'Edit'}
                </button>
            </div>

            {editMode ? (
                <div>
                    <div
                        style={{
                            position: 'relative',
                            paddingLeft: '40px',
                            marginLeft: '10px',
                            borderLeft: '2px solid #e5e7eb',
                        }}
                    >
                        {tableData.map((row, index) => (
                            <div style={{ position: 'relative', marginBottom: '35px' }} key={row.id}>
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: '-65px',
                                        top: '0',
                                        backgroundColor: '#e0e7ff',
                                        color: '#3b82f6',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        minWidth: '40px',
                                        textAlign: 'center',
                                    }}
                                >
                                    Why {row.id}
                                </div>

                                <input
                                    type="text"
                                    style={{
                                        border: '1px solid #d1d5db',
                                        borderRadius: '4px',
                                        padding: '6px 10px',
                                        width: '100%',
                                        fontSize: '0.9rem',
                                        marginBottom: '8px',
                                        fontWeight: 'bold',
                                        color: '#111827'
                                    }}
                                    value={row.point}
                                    disabled={row.id > 1}
                                    onChange={(e) => handleInputChange(row.id, 'point', e.target.value)}
                                    placeholder="Question "
                                />

                                <input
                                    type="text"
                                    style={{
                                        border: '1px solid #d1d5db',
                                        borderRadius: '4px',
                                        padding: '6px 10px',
                                        width: '100%',
                                        fontSize: '0.9rem',
                                        marginBottom: '8px',
                                        color: '#6b7280'
                                    }}
                                    value={row.reason}
                                    onChange={(e) => handleInputChange(row.id, 'reason', e.target.value)}
                                    placeholder="Answer / Reason"
                                />

                                <div className="d-flex align-items-center mt-1">
                                    <span className="mr-2 text-muted" style={{ fontSize: '0.85rem', minWidth: '50px' }}>Cause:</span>
                                    <input
                                        type="text"
                                        style={{
                                            border: '1px solid #d1d5db',
                                            borderRadius: '4px',
                                            padding: '6px 10px',
                                            width: '100%',
                                            fontSize: '0.9rem',
                                            marginBottom: 0,
                                            backgroundColor: '#f0f9ff',
                                            color: '#0369a1',
                                            fontWeight: '600'
                                        }}
                                        value={row.cause}
                                        onChange={(e) => handleInputChange(row.id, 'cause', e.target.value)}
                                        placeholder="Root Cause"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <div className="mb-4">
                            <div
                                style={{
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    height: '100%',
                                    border: 'none',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    Conclusion
                                </div>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={finalConclusion}
                                    onChange={(event, editor) => setFinalConclusion(editor.getData())}
                                    config={{ toolbar: ['bold', 'italic', 'link', 'bulletedList'] }}
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <div
                                style={{
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    height: '100%',
                                    border: 'none',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    Action Plan
                                </div>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={actionPlan}
                                    onChange={(event, editor) => setActionPlan(editor.getData())}
                                    config={{ toolbar: ['bold', 'italic', 'link', 'bulletedList'] }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="text-end mt-2 mb-5">
                        <button disabled={rca_loading} onClick={handleSave} type="submit" className="btn btn-primary px-4">
                            Save {rca_loading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ml-2" />}
                        </button>
                    </div>
                </div>
            ) : (
                <>
                    <div
                        style={{
                            position: 'relative',
                            paddingLeft: '40px',
                            marginLeft: '10px',
                            borderLeft: '2px solid #e5e7eb',
                        }}
                    >
                        {tableData.length > 0 && tableData.some(row => row.point || row.reason || row.cause) ? (
                            tableData.map((row, index) => (
                                <div style={{ position: 'relative', marginBottom: '35px' }} key={row.id}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: '-65px',
                                            top: '0',
                                            backgroundColor: '#e0e7ff',
                                            color: '#3b82f6',
                                            fontSize: '0.7rem',
                                            fontWeight: '700',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            minWidth: '40px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        Why {row.id}
                                    </div>

                                    <div
                                        style={{
                                            fontWeight: '700',
                                            fontSize: '1rem',
                                            color: '#111827',
                                            marginBottom: '6px',
                                        }}
                                    >
                                        {row.point || (index === 0 ? "Hose failed" : "Why did this happen?")}
                                    </div>

                                    <div
                                        style={{
                                            color: '#6b7280',
                                            fontSize: '0.95rem',
                                            marginBottom: '10px',
                                        }}
                                    >
                                        {row.reason || "-"}
                                    </div>

                                    {row.cause && (
                                        <div>
                                            <span
                                                style={{
                                                    color: '#6b7280',
                                                    fontSize: '0.85rem',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                Cause:
                                            </span>
                                            <span
                                                style={{
                                                    backgroundColor: '#e0f2fe',
                                                    color: '#0369a1',
                                                    fontSize: '0.8rem',
                                                    fontWeight: '600',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {row.cause}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="text-muted">No analysis data available.</div>
                        )}
                    </div>

                    <div className="row mt-4 mb-5">
                        <div className="col-md-6 mb-3">
                            <div
                                style={{
                                    backgroundColor: '#e6f4ea',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    height: '100%',
                                    border: 'none',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    CONCLUSION
                                </div>
                                <div
                                    style={{
                                        fontSize: '1.1rem',
                                        fontWeight: '700',
                                        color: '#111827',
                                        marginBottom: '20px'
                                    }}
                                >
                                    {finalConclusion ? (
                                        <div dangerouslySetInnerHTML={{ __html: finalConclusion }} />
                                    ) : (
                                        "-"
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div
                                style={{
                                    backgroundColor: '#e6f4ea',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    height: '100%',
                                    border: 'none',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    ACTION PLAN
                                </div>
                                <div
                                    style={{
                                        fontSize: '1.1rem',
                                        fontWeight: '700',
                                        color: '#111827',
                                        marginBottom: '20px'
                                    }}
                                >
                                    {actionPlan ? (
                                        <div dangerouslySetInnerHTML={{ __html: actionPlan }} />
                                    ) : (
                                       "-"
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default RootCauseAnalysis;